<ada-container verticalSpacing="Small">
	<ada-push-button
		#AddStepButton
		data-testid="add-sensor-action-sequence-button"
		id="AddStepButton"
		[adaClick]="openActionStepOverlay.bind(this)"
		[icon]="'faPlus'"
		[isDisabled]="isDisabled"
		[look]="'Outline'"
		[size]="'Small'"
		[text]="'Add Sensor Action Step'"
	/>
	<ada-table
		#SensorActionStepTable
		data-testid="SensorActionStepTable"
		[data]="actionStepData$ | async"
		[dragRowsEnabled]="!isDisabled"
		[includeActionsColumn]="true"
		[includeHeaderMenu]="false"
		[includeSorting]="false"
		[isReorderable]="true"
		[rowMenu]="SensorActionsTableRowMenu"
		(rowMoved)="onRowMoved($event)"
	>
		<ng-template
			adaTableColumn
			let-row
		>
			<ada-text [content]="row.sensorActionExpression || '--'" />
		</ng-template>
	</ada-table>
	<ada-menu
		#SensorActionsTableRowMenu
		[items]="sensorActionsTableRowMenus"
		(isOpenChange)="disableSensorActionsRowMenus($event)"
	/>
	<ada-container
		horizontalSpacing="Medium"
		[colCount]="0"
	>
		<ada-label content="Primary Step">
			<ada-text
				content="Index of the primary step in the sequence (0-based)."
				data-container-selector="label-info-text"
			/>
		</ada-label>
		<ada-input
			type="number"
			[isDisabled]="isDisabled"
			[max]="SensorActionStepTable.totalRowCount ? SensorActionStepTable.totalRowCount - 1 : 0"
			[min]="0"
			[value]="sequence.primaryStep"
			(valueChange)="setPrimaryStep(+$event)"
		/>
	</ada-container>
</ada-container>
<ada-overlay
	#ActionStepOverlay
	id="ActionStepOverlay"
	[beforeSubmit]="validateStep.bind(this)"
	[confirmText]="(editingIndex > -1 ? 'Edit' : 'Add') + ' Sensor Action Step'"
	[title]="(editingIndex > -1 ? 'Editing' : 'Adding') + ' Sensor Action Step'"
	(submit)="addActionStep($event)"
>
	<ada-container *adaTemplateMarker>
		<ada-container
			*ngIf="editingIndex >= 0"
			ada-background-color="background"
			class="ada-editor-sticky-header"
			horizontalAlignmentOfChildren="spaceBetween"
			[colCount]="0"
		>
			<ada-push-button
				data-testid="previous-sensor-action-step-button"
				icon="faAngleLeft"
				look="flat"
				margin="0px 0px 0px {{ UI.Spacing.SPACING_MEDIUM }}"
				size="small"
				text="Previous"
				[adaClick]="loadPreviousStep | adaBindMethod: this"
				[isDisabled]="isDisabled || editingIndex === 0"
			/>
			<ada-push-button
				data-testid="next-sensor-action-step-button"
				icon="faAngleRight"
				iconPosition="right"
				look="flat"
				size="small"
				text="Next"
				[adaClick]="loadNextStep | adaBindMethod: this"
				[isDisabled]="isDisabled || editingIndex === sequence?.steps?.length - 1"
			/>
		</ada-container>
		<ada-container
			verticalSpacing="Medium"
			[colCount]="4"
			[padding]="UI.Spacing.SPACING_LARGE"
		>
			<ng-container *ngIf="stepError$ | async as _error">
				<ada-alert
					type="error"
					[colSpan]="4"
					[isClosable]="false"
					[title]="_error"
				/>
			</ng-container>
			<ada-text
				content="Action Expression"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-container
				[colCount]="2"
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-expression-language-editor
					#ExpressionEditor
					data-testid="sesnor-action-expression-input"
					[customCompletionItems]="availableProperties"
					[expressionName]="propertyName"
					[isDisabled]="isDisabled"
					[objectId]="metadataObject?.objectId"
					[overridesClassName]="contextClassName()"
					[propertyMap]="metadataObject | adaSerializedPropertyMap"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[(expression)]="overlayStep.sensorActionExpression"
				/>
			</ada-container>
			<ada-label
				content="Primary Action"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			>
				<ada-text
					content="The name or Object ID of the primary action in the action expression"
					data-container-selector="label-info-text"
				/>
			</ada-label>
			<ada-container
				[colCount]="2"
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					data-testid="sensor-action-expression-primary-action"
					placeholder="Primary Action name or ID"
					[isDisabled]="isDisabled"
					[showAsFullWidth]="true"
					[(value)]="overlayStep.primaryAction"
				/>
			</ada-container>
			<ng-container *ngIf="returnCodeError$ | async as _error">
				<ada-alert
					type="error"
					[colSpan]="4"
					[isClosable]="false"
					[title]="_error"
				/>
			</ng-container>
			<ada-text
				content="Return Codes"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-container
				[colCount]="2"
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<div class="ada-container ada-colspan-3 ada-col-0">
					<ada-push-button
						#AddReturnCodeButton
						data-testid="add-return-code-button"
						icon="faPlus"
						id="AddReturnCodeButton"
						look="Outline"
						size="Small"
						text="Add Return Code"
						[adaClick]="addReturnCode | adaBindMethod: this"
						[isDisabled]="isDisabled"
						[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					/>
				</div>
				<ada-table
					#ReturnCodeTable
					id="ReturnCodeTable"
					[data]="returnCodeData$ | async"
					[includeActionsColumn]="true"
					[includeSorting]="false"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[rowMenu]="ReturnCodeRowMenu"
				>
					<ng-template
						adaTableColumn
						let-row
						let-rowIndex="rowIndex"
					>
						<ada-input
							attr.data-testid="row-{{ rowIndex }}-return-code-input"
							placeholder="Return code"
							type="number"
							[isDisabled]="isDisabled"
							[showAsFullWidth]="true"
							[(value)]="row.returnCode"
						/>
					</ng-template>
					<ng-template
						adaTableColumn
						let-row
						let-rowIndex="rowIndex"
					>
						<ada-combo
							attr.data-testid="row-{{ rowIndex }}-behavior-input"
							[isDisabled]="isDisabled"
							[options]="behaviorOptions"
							[showAsFullWidth]="true"
							[(value)]="row.behavior"
						/>
					</ng-template>
				</ada-table>
				<ada-menu
					#ReturnCodeRowMenu
					[isDisabled]="isDisabled"
					[items]="returnCodeTableRowMenus"
				/>
			</ada-container>
			<ada-text
				content="Default Behavior"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-container
				[colCount]="2"
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-combo
					data-testid="default-behavior-input"
					[isDisabled]="isDisabled"
					[options]="behaviorOptions"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[(value)]="overlayStep.defaultBehavior"
				/>
			</ada-container>
			<ada-text
				content="Ignore Runtime Errors"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-container
				[colCount]="2"
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-toggle-switch
					data-testid="ignore-runtime-errors-input"
					[isDisabled]="isDisabled"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[(isToggled)]="overlayStep.ignoreRuntimeErrors"
				/>
			</ada-container>
		</ada-container>
	</ada-container>
</ada-overlay>
